














































































import {getCategoryByType} from '@/api/category'
import {getSetmealPage, enableOrDisableSetmeal,deleteSetmeal} from '@/api/setMeal'

export default {
  //模型数据
  data() {
    return {
      name: '', //套餐名称，对应上面的输入框
      page: 1, //页码
      pageSize: 10, //每页记录数
      total: 0, //总记录数
      records: [], //当前页要展示的数据集合
      options: [],
      categoryId: '', //分类id
      statusArr:[
        {
          value: '0',
          label: '停售'
        },
        {
          value: '1',
          label: '启售'
        }
      ],
      status: '', //售卖状态,
      multipleSelection: ''//当前表格选中的多个元素
    }
  },
  created() {
    getCategoryByType({type: 2}).then(res => {
      if(res.data.code === 1) {
        this.options = res.data.data
      }
    })

    //页面加载完成后查询套分页数据
    this.pageQuery()
  },
  methods: {
    //分页查询
    pageQuery() {
      //封装分页查询参数
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.name,
        status: this.status,
        categoryId: this.categoryId
      }

      getSetmealPage(params).then(res => {
        if(res.data.code === 1){
          this.total = res.data.data.total
          this.records = res.data.data.records
        }
      })
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageQuery()
    },
    handleCurrentChange(page) {
      this.page = page
      this.pageQuery()
    },
    //套餐启售停售操作
    handleStartOrStop(row) {
      const p = {
        id: row.id,
        status: !row.status ? 1: 0
      }

      this.$confirm('确认调整当前套餐的售卖状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          enableOrDisableSetmeal(p).then(res => {
            if(res.data.code === 1) {
              this.$message.success('套餐售卖状态修改成功！')
              this.pageQuery()
            }
          })
        })
    },
    //删除套餐
    handleDelete(type: string,id: string) {
      this.$confirm('确认删除当前指定的套餐, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = ''
          if(type == 'B'){//批量删除
            const arr = new Array
            this.multipleSelection.forEach(element => {//1,2,3
              arr.push(element.id)
            })
            param = arr.join(',')
          }else{//单一删除
            param = id
          }

          deleteSetmeal(param).then(res => {
            if(res.data.code === 1){
              this.$message.success('删除成功！')
              this.pageQuery()
            }else{
              this.$message.error(res.data.msg)
            }
          })
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      // console.log('当前表格勾选了几项：' + val.length)
      // val.forEach(element => {
      //   console.log('id=' + element.id)
      // })
    }
  }
}
